import { FaIcon } from "lib/FaIcon";
import { push } from "pages/search/api/filterUrlMaker";
import React from "react";
import { Button } from "react-bootstrap";

export const ClearFiltersButton = () => (
  <Button variant={"link border-0 px-2 rounded-0"} onClick={() => push({})}>
    <FaIcon icon="fas fa-times text-secondary" align="" />
  </Button>
);
